import { track } from '@/lib/analytics';

/** Formats a tutorial can be published in. Only `tour` and `article` exist so far (VOL-141). */
export type TutorialFormat = 'tour' | 'video' | 'article' | 'demo';

/**
 * A finished tutorial is stored as a `tutorial:<id>` entry of the onboarding `completedSteps`
 * (no dedicated column, decision of 15/10/2026). The backend keeps these entries when
 * "Prise en main" is replayed.
 */
export const TUTORIAL_STEP_PREFIX = 'tutorial:';

/** "Prise en main": the onboarding tour, done when the onboarding state is completed. */
export const GETTING_STARTED_TUTORIAL_ID = 'getting-started';

export function tutorialStepId(tutorialId: string): string {
  return `${TUTORIAL_STEP_PREFIX}${tutorialId}`;
}

export function isTutorialCompleted(completedSteps: readonly string[], tutorialId: string): boolean {
  return completedSteps.includes(tutorialStepId(tutorialId));
}

export function trackTutorialStarted(tutorialId: string, format: TutorialFormat): void {
  track('tutorial_started', { tutorial_id: tutorialId, format });
}

export function trackTutorialCompleted(tutorialId: string, format: TutorialFormat): void {
  track('tutorial_completed', { tutorial_id: tutorialId, format });
}
